(function (process,global,Buffer,__argument0,__argument1,__argument2,__argument3,__filename,__dirname){
const $ = window.jQuery

$(() => {
  $('.dropdown-button').click(function() {
    var dropdown = $(this).parent('.dropdown')

    if(dropdown.hasClass('dropdown--active')) {
      $('.dropdown').removeClass('dropdown--active')
    } else {
      $('.dropdown').removeClass('dropdown--active')
      dropdown.toggleClass('dropdown--active')
    }

    return false
  })

  var eventType = (navigator.userAgent.match(/iPad/i)) ? "touchstart" : "click"
  $('html, body').on(eventType, function(e) {
    if($(e.target).closest('.dropdown').length === 0) {
      $('.dropdown').removeClass('dropdown--active')
    }
  })

  $('.dropdown .formcheckbox input').change(function() {
    var checkbox = $(this)
    var type = checkbox.data('type')

    if (!type) {
      return // Skip this one
    }

    if(type.indexOf('-master') >= 0) {
      $('[data-type=\'' + type.replace('-master', '') + '\']').prop('checked', checkbox.is(':checked'))
    } else {
      if(!checkbox.is(':checked')) {
        $('[data-type=\'' + type + '-master\']').prop('checked', false)
      } else if ($('[data-type=\'' + type + '\']').not(':checked').length === 0) {
        $('[data-type=\'' + type + '-master\']').prop('checked', true)
      }

    }
  })
})

}).call(this,require("rH1JPG"),typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {},require("buffer").Buffer,arguments[3],arguments[4],arguments[5],arguments[6],"/_dropdown.js","/")